import { createFileRoute } from "@tanstack/react-router";

import { PresenterDebugPreview } from "~/features/gameSession/components/PresenterDebugView/PresenterDebugPreview.tsx";
import { parsePresenterDebugSearch } from "~/features/gameSession/components/PresenterDebugView/presenterDebugSearch.ts";
import { resolvePresenterDebugSelection } from "~/features/gameSession/components/PresenterDebugView/presenterDebugUtils.ts";

const PresenterDebugPreviewPage = () => (
    <PresenterDebugPreview {...resolvePresenterDebugSelection(Route.useSearch())} />
);

export const Route = createFileRoute("/_auth/dev/presenter/preview")({
    validateSearch: parsePresenterDebugSearch,
    component: PresenterDebugPreviewPage,
});
